export default __webpack_public_path__ + "static/testhq-logo-757d680810d4da2b4269c9f968186736.png";